import React from 'react'

const TalkLetter = () => {
  return (
    <div className="w-[90%] md:w-[75%] mx-auto " data-aos="fade-up" data-aos-duration="1500">
      <div className="text-center -mt-40 mb-10 bg-primary rounded-xl py-6 px-4 sm:px-10 text-slate-100 flex flex-col items-center justify-center space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center sm:space-x-6 space-y-3 sm:space-y-0">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="#2BEAD2" d="M12 2A10 10 0 0 0 2 12a9.89 9.89 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20Zm0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20Zm5-9H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm-2 4H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2ZM9 9h6a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2Z" />
            </svg>
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold font-custom-serif text-center sm:text-left">
            Let's talk about your <br className="hidden sm:block" /> specific needs.
          </h2>
          <span className="-scale-x-100">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="#2BEAD2" d="M12 2A10 10 0 0 0 2 12a9.89 9.89 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20Zm0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20Zm5-9H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm-2 4H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2ZM9 9h6a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2Z" />
            </svg>
          </span>
        </div>

        <p className="text-base sm:text-lg text-center max-w-xl">
          Get the latest in mental health, free events, feature updates, or more.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="px-6 py-2 bg-transparent border border-accent hover:scale-90 transition duration-300 shadow rounded text-white">
            Try Yourself
          </button>
          <button className="px-6 py-2 bg-accent/80 hover:scale-90 transition duration-300 shadow text-white rounded">
            Get Started
          </button>
        </div>
      </div>
    </div>
  )
}

export default TalkLetter
